(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("Highcharts"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["Highcharts", ], factory);
	else if(typeof exports === 'object')
		exports["tsr"] = factory(require("Highcharts"), require("vue"));
	else
		root["tsr"] = factory(root["Highcharts"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__0bd6__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 